<template>
  <div>
    <base-header class="header pb-3 py-5 pt-md-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid align-items-center mb-3">
        <div class="col-12 d-block d-md-none">
          <router-link
            to="/colaborador/inicio"
            class="btn-link font-weight-normal text-white"
            title="Voltar para o início"
            ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
          >
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--5">
      <div
        class="
          col-xl-6
          offset-xl-2
          col-xl-8 col-lg-12
          mb-4
          card
          vld-parent
          px-2
        "
        ref="news_feed"
      >
        <p class="mb-1 mt-3">
          <a @click="handleViewUser(news)" class="pointer">
            <img
              width="30"
              height="30"
              v-if="this.profilePicture"
              :src="profilePicture"
              class="rounded-circle"
              alt="foto de perfil"
            />
            <i v-else class="fas fa-user-circle user-default-logo"></i>
            <span class="ml-2">{{
              news.author.collaborator
                ? news.author.collaborator.name
                : news.author.company.brand_name
            }}</span>
          </a>
          <i
            v-if="isSelfEdit(news)"
            @click="$router.push(`/colaborador/publicacoes/${news.id}/editar`)"
            v-tooltip="'Editar publicação'"
            class="fas fa-edit float-right pointer mr-2"
          ></i>
        </p>
        <div class="mb-2">
          <badge type="seagreen px-3 float-right">{{
            newsType[news.type]
          }}</badge>
        </div>
        <img
          v-if="news.image_url"
          class="image-feed rounded"
          :src="news.image_url"
          alt="..."
        />
        <quill-editor
          v-model="news.body"
          :options="editorReadOnly"
          disabled="disabled"
        >
        </quill-editor>
        <p class="px-3" v-if="news.type !== 'news'">
          {{ news.title }}
        </p>
        <p class="mb-2">
          <span class="font-date float-right">{{
            formatDate(news.created_at, "LL")
          }}</span>
        </p>
        <div class="btn-group mb-3 d-flex border-group">
          <base-button
            class="btn btn-white py-1"
            :title="!news.liked ? 'Curtir' : 'Descurtir'"
            @click="handleLike"
          >
            <div v-if="!news.liked" class="">
              <i class="far fa-heart fa-sm"></i>
              {{ news.likes }}
            </div>
            <div v-else class="">
              <i class="fas fa-heart fa-sm text-primary"></i>
              {{ news.likes }}
            </div>
          </base-button>
          <base-button class="btn btn-white disabled py-1" type="">
            <i class="far fa-comment fa-sm"></i> {{ news.comments.length }}
          </base-button>
        </div>
        <hr />

        <h2>Comentários</h2>
        <div v-if="!this.news.comments.length">
          <p class="description mb-3">
            Ninguém comentou ainda! Seja o primeiro a comentar.
          </p>
        </div>
        <div
          ref="news_table"
          :key="index"
          v-for="(comment, index) in news.comments"
        >
          <div class="mb-0">
            <p class="mb-1 mt-2">
              <img
                width="30"
                height="30"
                v-if="validImageComments(comment)"
                :src="imageComments(comment)"
                class="rounded-circle"
                alt="foto de perfil"
              />
              <i v-else class="fas fa-user-circle user-default-logo"></i>
              <span class="ml-2">{{
                comment.authorCollaborator
                  ? comment.authorCollaborator.name
                  : comment.authorCompany.company_name
              }}</span>
            </p>
            <i class="far fa-comment ml-2 mr-1"></i>
            {{ comment.comment
            }}<i
              v-if="isSelf(comment)"
              @click="handleOpenModalConfirmation(comment.id)"
              v-tooltip="'Excluir comentário!'"
              class="far fa-trash-alt float-right ml-1 text-warning"
            ></i>
          </div>
          <div
            class="mx-3"
            :key="index"
            v-for="(reply, index) in comment.replies"
          >
            <div class="mb-0">
              <p class="mb-1 mt-2">
                <img
                  width="30"
                  height="30"
                  v-if="validImageComments(reply)"
                  :src="imageComments(reply)"
                  class="rounded-circle"
                  alt="foto de perfil"
                />
                <i v-else class="fas fa-user-circle user-default-logo"></i>
                <span class="ml-2">{{
                  reply.authorCollaborator
                    ? reply.authorCollaborator.name
                    : reply.authorCompany.company_name
                }}</span>
              </p>
              <i class="far fa-comments ml-3 mr-1"></i>
              {{ reply.comment
              }}<i
                v-if="isSelf(reply)"
                @click="handleOpenModalConfirmation(reply.id)"
                v-tooltip="'Excluir comentário!'"
                class="far fa-trash-alt float-right ml-1 text-warning"
              ></i>
            </div>
          </div>
          <span
            @click="handleResponse(comment)"
            class="mb-3 ml-2 text-blue cursor-pointer"
            >Responder</span
          >
          <hr />
        </div>
        <b>Comentar</b>
        <div v-if="commentResponse" class="row">
          <div class="col-12">
            <span class="description"
              >Respondendo a "{{ commentResponse }}"</span
            >
            <i
              class="float-right text-red fas fa-times"
              v-tooltip="'Remover seleção'"
              @click="handleResponseRemove"
            >
            </i>
          </div>
        </div>
        <base-input
          placeholder="Escreva seu comentário"
          v-model="model.newComment"
        ></base-input>
        <div class="text-right mb-3">
          <base-button
            v-if="commentResponse"
            @click="handleCommentResponse(commentResponseId)"
            class="btn"
            :disabled="loaderComment"
            >Publicar</base-button
          >
          <base-button
            v-else
            :disabled="loaderComment"
            @click="handleComment"
            class="btn"
            >Publicar</base-button
          >
        </div>
      </div>
    </div>
    <modal
      :show.sync="modal.modalConfirmation"
      modal-classes="modal-default modal-dialog-centered"
      body-classes="pb-0"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_confirmation_delete">
        <div class="py-3 text-center">
          <i class="fa fa-trash fa-3x"></i>
          <h4 class="heading mt-4">
            Você realmente deseja excluir o comentário?
          </h4>
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="modal.modalConfirmation = false"
        >
          Voltar
        </base-button>
        <base-button
          type="white text-danger"
          @click="handleDeleteComment(idDelete)"
        >
          Confirmar exclusão
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import api from "@/services/api";
import { getUserId } from "@/services/auth";

export default {
  name: "post_card",
  components: { quillEditor },
  data() {
    return {
      user_id: getUserId(),
      news: {
        author: {
          collaborator: {
            name: "",
            profilePicture: {
              url: ""
            }
          },
          company: {
            brand_name: "",
            profilePicture: {
              url: ""
            }
          }
        },
        comments: []
      },
      loaderComment: false,
      limit: 10,
      empty: {
        news: ""
      },
      profilePicture: "",
      commentResponse: "",
      commentResponseId: "",
      model: { newComment: "" },
      editorReadOnly: {
        placeholder: "...",
        readOnly: true,
        theme: "bubble"
      },
      modal: {
        modalConfirmation: false
      },
      idDelete: 0,
      newsType: {
        notice: "Aviso",
        event: "Evento",
        training: "Treinamento",
        dynamic: "Dinâmica"
      }
    };
  },
  async mounted() {
    this.loadNews(`&limit=${this.limit}`);
  },
  methods: {
    isSelf(comment) {
      const user = comment.authorCompany || comment.authorCollaborator;
      return Number(user.user_id) === Number(this.user_id);
    },
    isSelfEdit(news) {
      return Number(news.author.id) === Number(this.user_id);
    },
    handleViewUser(news) {
      this.$router.push(
        news.author.collaborator
          ? `/colaborador/colaboradores/${news.author.id}/visualizar`
          : `/colaborador/empresa/${news.author.id}/visualizar`
      );
    },
    handleResponseRemove() {
      this.commentResponse = "";
      this.commentResponseId = "";
    },
    handleResponse(comment) {
      this.commentResponse = comment.comment;
      this.commentResponseId = comment.id;
    },
    validImageComments(comment) {
      if (comment.authorCollaborator) {
        return comment.authorCollaborator.profilePicture ? true : false;
      } else if (comment.authorCompany) {
        return comment.authorCompany.profilePicture ? true : false;
      }
    },
    imageComments(comment) {
      if (comment.authorCollaborator) {
        return comment.authorCollaborator.profilePicture.url
          ? comment.authorCollaborator.profilePicture.url
          : "";
      } else if (comment.authorCompany) {
        return comment.authorCompany.profilePicture.url
          ? comment.authorCompany.profilePicture.url
          : "";
      }
    },
    handleOpenModalConfirmation(id) {
      this.modal.modalConfirmation = true;
      this.idDelete = id;
    },
    async handleDeleteComment(id) {
      try {
        await api.delete(`/collaborator/news/${this.news.id}/comment/${id}`);
        this.modal.modalConfirmation = false;
        this.loadNews();
      } catch (error) {
        this.$toasted.error("Ocorreu um erro ao excluir o comentário!");
      }
    },
    async handleCommentResponse(id) {
      this.loaderComment = true;
      try {
        await api.post(`/collaborator/news/${this.news.id}/comment`, {
          comment: this.model.newComment,
          reply_to: id
        });
        this.model.newComment = "";
        this.loadNews();
        this.commentResponse = "";
        this.commentResponseId = "";
        this.loaderComment = false;
        this.$toasted.show("Comentário realizado com sucesso");
      } catch (e) {
        this.loaderComment = false;
        const genericError = "Ocorreu um erro ao comentar!";
        const hasErrorResponseData = e.response && e.response.data;
        let customError = genericError;
        if (hasErrorResponseData) {
          const data = e.response.data.error
            ? e.response.data.error
            : e.response.data.errors;
          if (data[0] && data[0].message) customError = data[0].message;
          else if (data.message) customError = data.message;
        }
        this.$toasted.error(hasErrorResponseData ? customError : genericError);
      }
    },
    async handleComment() {
      this.loaderComment = true;
      try {
        await api.post(`/collaborator/news/${this.news.id}/comment`, {
          comment: this.model.newComment
        });
        this.model.newComment = "";
        this.loadNews();
        this.loaderComment = false;
        this.$toasted.show("Comentário realizado com sucesso");
      } catch (e) {
        this.loaderComment = false;
        const genericError = "Ocorreu um erro ao comentar!";
        const hasErrorResponseData = e.response && e.response.data;
        let customError = genericError;
        if (hasErrorResponseData) {
          const data = e.response.data.error
            ? e.response.data.error
            : e.response.data.errors;
          if (data[0] && data[0].message) customError = data[0].message;
          else if (data.message) customError = data.message;
        }
        this.$toasted.error(hasErrorResponseData ? customError : genericError);
      }
    },
    async handleLike() {
      if (!this.news.liked) {
        this.news.likes += 1;
      } else if (this.news.liked && this.news.likes > 0) {
        this.news.likes -= 1;
      }
      this.news.liked = !this.news.liked;
      try {
        await api.put(`/collaborator/news/${this.news.id}/like`);
      } catch (error) {
        this.news.likes -= 1;
        this.news.liked = !this.news.liked;
        this.$toasted.error("Falha ao curtir");
      }
    },
    truncate(text, stop = 150, clamp = "...") {
      if (!text) return "N/A";
      return text.slice(0, stop) + (stop < text.length ? clamp : "");
    },
    async loadPublications(targetObjName, loaderRef, errorMsg) {
      this.empty[targetObjName] = false;
      const loader = this.$loading.show({
        container: loaderRef,
        width: 90,
        height: 90
      });
      try {
        const { data } = await api.get(
          `/collaborator/news/${this.$route.params.id}`
        );
        if (data) {
          this.news = data;
          if (this.news.author.collaborator) {
            this.profilePicture = this.news.author.collaborator.profilePicture
              ? this.news.author.collaborator.profilePicture.url
              : "";
          } else if (this.news.author.company) {
            this.profilePicture = this.news.author.company.profilePicture
              ? this.news.author.company.profilePicture.url
              : "";
          }
        } else this.empty[targetObjName] = true;
        loader.hide();
      } catch (e) {
        this.$toasted.error(`Ocorreu um erro ao recuperar ${errorMsg}`);
      }
    },
    async loadNews() {
      await this.loadPublications("news", this.$refs.news_table, "as notícias");
    }
  }
};
</script>
<style scoped>
.font-date {
  font-size: 0.8rem;
  color: #8c8c8c;
}
.card-image {
  width: 115px;
  height: 115px;
  border-radius: 10%;
  margin: auto;
}
.fab {
  color: #f6f9fc;
}
.pointer {
  cursor: pointer;
}
</style>
<style>
.nv-container-read-only .quill-editor .ql-container,
.nv-container-read-only .quill-editor .ql-container .ql-editor {
  min-height: 5rem;
  max-height: 10rem;
  width: 100%;
}

p > strong {
  font-weight: bold !important;
}
</style>
<style scoped>
.image-feed {
  max-width: 500;
  max-height: 500;
}
.user-default-logo {
  font-size: 30px;
  vertical-align: middle;
}
</style>
